import { css } from 'styled-components';
import { vars } from '../theme';
import colors from './colors';

export const customScrollBar = css`
    &::-webkit-scrollbar {
        background-color: ${colors.neutral200};
        width: 6px;
        height: 6px;
        border-radius: ${vars.radius.full};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${colors.neutral600};
        border-radius: ${vars.radius.full};
        &:active,
        &:hover {
            background-color: ${colors.neutral700};
        }
    }
`;

/**
 * Hides the browser scrollbar while keeping the element scrollable — the inverse of
 * `customScrollBar`, which styles a *visible* scrollbar. Covers Firefox
 * (`scrollbar-width`), legacy Edge/IE (`-ms-overflow-style`), and WebKit/Blink
 * (`::-webkit-scrollbar`).
 *
 * Single source of truth for this rule set: `HBBox`/`HBFlex`/`HBGrid`'s `hideScrollbar`
 * prop and HBTable's scroll container both delegate here, so the vendor-prefix list
 * cannot drift between them.
 */
export const hideScrollbar = css`
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;
